export const hasEnoughSpaceForPreload = (
	fileSizeValue: number | null | undefined,
	availableBytesValue: number | null | undefined
): boolean => {
	if (availableBytesValue === null || availableBytesValue === undefined) {
		return true
	}

	const availableBytes = Number(availableBytesValue)
	if (!Number.isFinite(availableBytes)) {
		return true
	}

	const fileSize = Number(fileSizeValue)
	if (!Number.isFinite(fileSize) || fileSize <= 0) {
		return true
	}

	return fileSize <= availableBytes
}
